import { ImagesHeaderUserSvg } from '@/assets/images_header.assets';
import DefaultButton from '@/components/common/default/DefaultButton';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { HeaderEnum } from '@/types/translations/HeaderEnum';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import UserMenuDialog from './UserMenuDialog/UserMenuDialog';
import { UserMenuProps } from '@/types/props/components/layout';
import UserMenuLanguageSwitcher from './UserMenuLanguageSwitcher';
import { usePathname } from 'next/navigation';

export default function UserMenu({
  ctaCountQuery,
  notificationsQuery,
}: UserMenuProps) {
  const pathname = usePathname();
  const { translate } = useTypedTranslation<HeaderEnum>('header');
  const [openUserMenu, setOpenUserMenu] = useState(false);

  useEffect(() => {
    setOpenUserMenu(false);
  }, [pathname]);

  return (
    <>
      <div className="tw-flex tw-items-center tw-gap-2">
        <UserMenuLanguageSwitcher />
        <DefaultButton
          onClick={() => setOpenUserMenu(true)}
          aria-label={translate(HeaderEnum['mobile_menu.open_user_menu'])}
        >
          <Image src={ImagesHeaderUserSvg} alt="menu" width={31} height={30} />
        </DefaultButton>
      </div>
      <UserMenuDialog
        open={openUserMenu}
        onClose={() => setOpenUserMenu(false)}
        ctaCountQuery={ctaCountQuery}
        notificationsQuery={notificationsQuery}
      />
    </>
  );
}
